import ActionTypes from './actionTypes';

export function fetchRoles() {
  return {
    type: ActionTypes.ROLES.FETCH.REQUEST
  };
}

export function fetchRolesSuccess(roles) {
  return {
    type: ActionTypes.ROLES.FETCH.SUCCESS,
    payload: {
      roles
    }
  };
}

export function fetchRolesFailure() {
  return {
    type: ActionTypes.ROLES.FETCH.FAILURE
  };
}

export function resetAssignableRoles() {
  return {
    type: ActionTypes.ROLES.ASSIGN_ROLES.RESET,
  };
}

export function fetchAssignableRoles(grandParentCustomerNumber) {
  return {
    type: ActionTypes.ROLES.ASSIGN_ROLES.REQUEST,
    payload: { grandParentCustomerNumber }
  };
}

export function fetchAssignableRolesSuccess(roles) {
  return {
    type: ActionTypes.ROLES.ASSIGN_ROLES.SUCCESS,
    payload: {
      roles
    }
  };
}

export function fetchAssignableRolesFailure() {
  return {
    type: ActionTypes.ROLES.ASSIGN_ROLES.FAILURE
  };
}
